import React from 'react';
import { Area } from '../../../entities/Area';
import { ProductLeg } from '../../../entities/ProductLeg';
import { makeResolution } from '../../../entities/Resolution';
import AreasEditor, { AreaAction } from '../../AreasEditor';
import { PresetObj } from '../../../api-entities/PresetArea';

interface IProps {
  values: Array<Area>;
  grids: Array<string>;
  presetAreas: Array<PresetObj>;
  userPresetAreas: Array<PresetObj>;
  onChange: (areas: Array<Area>) => void;
  readonly?: boolean;
}

const AreasSelector = (props: IProps) => {
  const { values, grids, onChange, presetAreas, userPresetAreas, readonly } = props;

  const suggestArea = React.useCallback(
    input =>
      Promise.resolve(
        presetAreas.filter(x => x.name.toLowerCase().startsWith(input.toLowerCase()))
      ),
    [presetAreas]
  );

  const handleAreaAction = React.useCallback(
    (action: AreaAction) => {
      switch (action.type) {
        case 'create':
          onChange([...values, action.area]);
          break;

        case 'update': {
          const newAreas = values.slice();
          newAreas[action.index] = action.area;
          onChange(newAreas);
          break;
        }

        case 'delete': {
          const newAreas = values.slice();
          newAreas.splice(action.index, 1);
          onChange(newAreas);
          break;
        }
      }
    },
    [values, onChange]
  );

  const productLegs: Map<number, ProductLeg> = new Map(grids.map((grid, index) => {
    return [index, {
      grid: makeResolution(grid)
    }]
  }));

  return (
    <AreasEditor<Area>
      areaEntities={values}
      projectArea={area => area}
      handleAction={handleAreaAction}
      legs={productLegs}
      suggestArea={suggestArea}
      needsFocus={false}
      onBlur={() => undefined}
      acknowledgeFocusRequest={() => undefined}
      userPresetAreas={userPresetAreas}
      readonly={readonly}
    />
  )
}

export default AreasSelector;
